import { actionLog } from 'services/actionlog.service';
import { api } from 'services/api';

import { RealizacaoParaAutorizar, tamanhoDaEquipe } from './autorizacao-regras';

const ACAO = 'task_participants_approval';
const STATUS_OK = 'OK';
export const FALHA_AO_REGISTRAR = 'Não foi possível registrar sua decisão. Tente de novo.';

/**
 * Realizações com autorização de participantes do gestor no período (PAR-03). Lê o `autorizacao_participantes`,
 * versão enxuta do `need_approval_participants` (mesmo filtro, só os campos da página, PAR-60 a PAR-63).
 * Rejeita na falha: a página mostra o erro (PAR-13).
 */
export async function listarRealizacoes(inicio: number, fim: number, gestor: string): Promise<RealizacaoParaAutorizar[]> {
  const { data } = await api.post('find/autorizacao_participantes', { start: inicio, end: fim, player: gestor });
  if (!Array.isArray(data)) throw new Error('autorizacao_participantes não devolveu uma lista');
  return data;
}

/**
 * Grava a ação e resolve só quando o trigger responde "OK" (PAR-23). Na recusa, o erro leva o
 * `attributes.status` do trigger; sem status ou na falha de rede, o texto genérico (PAR-24).
 */
async function registrar(attributes: Record<string, unknown>): Promise<void> {
  let status: unknown;
  try {
    const resposta = await actionLog('me', ACAO, attributes);
    status = resposta?.action?.attributes?.status;
  } catch {
    throw new Error(FALHA_AO_REGISTRAR);
  }

  if (status !== STATUS_OK) {
    throw new Error(typeof status === 'string' && status ? status : FALHA_AO_REGISTRAR);
  }

  // Avisa quem conta pendências (cabeçalho, Home) para reler (PAR-25).
  document.dispatchEvent(new CustomEvent('reload:pendingapproval'));
}

/** Autorizar (PAR-20) ou não autorizar (PAR-21) a quantidade de participantes. */
export function registrarDecisao(realizacao: RealizacaoParaAutorizar, aprovada: boolean): Promise<void> {
  return registrar({ taskId: realizacao._id, approved: aprovada, quantity: tamanhoDaEquipe(realizacao) });
}

/** Desfazer a própria decisão (PAR-31). */
export function desfazerDecisao(realizacao: RealizacaoParaAutorizar): Promise<void> {
  return registrar({ taskId: realizacao._id, undo: true });
}
